import { Route } from "react-router";
import { Activate } from "@lending/pages/Common/MembershipShare/Activate";
import { MembershipShareDisclosures } from "@lending/pages/Common/MembershipShare/Disclosures";
import { MembershipShareDocumentsRequested } from "@lending/pages/Common/MembershipShare/DocumentsRequested";
import { Processing } from "@lending/pages/Common/MembershipShare/Processing";
import { Select } from "@lending/pages/Common/MembershipShare/Select";
import { Status } from "@lending/pages/Common/MembershipShare/Status";
import { MembershipShareSubmittingDocuments } from "@lending/pages/Common/MembershipShare/SubmittingDocuments";
import { UseDifferentEmail } from "@lending/pages/Common/MembershipShare/UseDifferentEmail";
import { VerifyEmail } from "@lending/pages/Common/MembershipShare/VerifyEmail";
import { MembershipShareGuard } from "./guards/MembershipShareGuard";

interface MembershipShareRoutesProps {
  fallbackPath: string;
}

const getMembershipShareRoutes = ({ fallbackPath }: MembershipShareRoutesProps) => (
  <Route path="membership-share" element={<MembershipShareGuard fallbackPath={fallbackPath} />}>
    <Route index element={null} />
    <Route path="select" element={<Select />} />
    <Route path="use-different-email" element={<UseDifferentEmail />} />
    <Route path="verify-email" element={<VerifyEmail />} />
    <Route path="activate" element={<Activate />} />
    <Route path="documents-requested" element={<MembershipShareDocumentsRequested />} />
    <Route path="disclosures" element={<MembershipShareDisclosures />} />
    <Route path="processing" element={<Processing />} />
    <Route path="submitting-documents" element={<MembershipShareSubmittingDocuments />} />
    <Route path="status" element={<Status />} />
  </Route>
);

export { getMembershipShareRoutes };
